import React, { memo } from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import styles from "./ota-configuration-backup-drawer-modal.module.scss";
import { Title } from "@src/components/atoms/title/title";
import { DrawerIconContainer } from "@src/components/atoms/drawer-icon-container/drawer-icon-container";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import BackupUploadIcon from "@src/assets/svg/backup-upload.svg";
import backupIcon from "@src/assets/svg/upload-icon-white.svg";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { Button } from "@src/components/atoms/buttons/button/button";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import { DrawerButtonWrapper } from "@src/components/molecules/drawer-button-wrapper/drawer-button-wrapper";
import { OtaBackupDrawerInterface } from "@src/types/ota-update";
import { Input2026 } from "@src/components/atoms/input-2026/input-2026";
import { Textarea } from "@src/components/atoms/textarea/textarea";
import OtaDrawerInfo from "@src/components/molecules/ota-drawer-info/ota-drawer-info";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { useOtaConfigurationBackupDrawerModal } from "./use-ota-configuration-backup-drawer-modal";

const cssClassName = "ota-configuration-backup-modal";
interface OtaBackupDrawerModalProps {
  inputValues: OtaBackupDrawerInterface;
  setInputValues: React.Dispatch<
    React.SetStateAction<OtaBackupDrawerInterface>
  >;
  fetchBackups: () => Promise<void>;
}
export const OtaConfigurationBackupDrawerModal = memo(
  ({
    inputValues,
    setInputValues,
    fetchBackups,
  }: OtaBackupDrawerModalProps) => {
    const {
      texts,
      handleCloseDrawerModal,
      handleSubmit,
      handleBackupNameChange,
      handleVersionChange,
      handleBackupNotesChange,
    } = useOtaConfigurationBackupDrawerModal({
      inputValues,
      setInputValues,
      fetchBackups,
    });

    return (
      <DrawerModal id="otaConfigurationBackupDrawerModal">
        <div className={styles[cssClassName]}>
          <FlexColumnContainer verticalGap={24}>
            <Title tag="h2" text={texts.createConfigurationBackupText} />
            <DrawerIconContainer icon={BackupUploadIcon} />

            <div className={styles[`${cssClassName}__content-wrapper`]}>
              <FlexRowContainer horizontalGap={8}>
                <img
                  className={styles[`${cssClassName}__container-icon`]}
                  alt={"Backup"}
                  src={backupIcon}
                />
                <p className={styles[`${cssClassName}__subtitle`]}>
                  {texts.backupDetailsText}
                </p>
              </FlexRowContainer>

              <div className={styles[`${cssClassName}__metadata-box`]}>
                <FlexColumnContainer>
                  <OtaDrawerInfo />
                </FlexColumnContainer>
                <Spacer16 />
                <Input2026
                  label={texts.backupNameText}
                  value={inputValues.backup_name}
                  onChange={(e) => handleBackupNameChange(e.target.value)}
                  placeholder={texts.namePlaceholderText}
                />
                <Input2026
                  label={texts.configurationVersionText}
                  value={inputValues.version}
                  onChange={(e) => handleVersionChange(e.target.value)}
                  placeholder={texts.namePlaceholderText}
                />
                <Textarea
                  label={texts.backupNotesText}
                  value={inputValues.backup_notes}
                  placeholder={texts.notesPlaceholderText}
                  onChange={(e) => handleBackupNotesChange(e.target.value)}
                />
              </div>

              <DrawerButtonWrapper>
                <ButtonWithLoader
                  fun={handleSubmit}
                  text={texts.createBackupText}
                  loading={false}
                />
                <Button
                  fun={handleCloseDrawerModal}
                  text={texts.cancelText}
                  variant={"secondary"}
                />
              </DrawerButtonWrapper>
            </div>
          </FlexColumnContainer>
        </div>
      </DrawerModal>
    );
  },
);

OtaConfigurationBackupDrawerModal.displayName =
  "OtaConfigurationBackupDrawerModal";
